const historyGetters = {
  exerciseLogsByDate(state: any) {
    if (!state.exerciseLogs) {
      return undefined;
    }
    let logs = [...state.exerciseLogs];

    const exerciseType = state.selectedExerciseLogTypeAndSkill.exerciseType;
    const exerciseSkill = state.selectedExerciseLogTypeAndSkill.exerciseSkill;
    if (exerciseType || exerciseSkill) {
      logs = logs.filter(log => {
        const typeMatched =
          log.exercise.type === state.selectedExerciseLogTypeAndSkill.exerciseType;
        const skillMatched =
          log.exercise.skill === state.selectedExerciseLogTypeAndSkill.exerciseSkill;
        return typeMatched && skillMatched;
      });
    }

    const sortedLogs = logs.sort((a, b): number => {
      return b.timestamp - a.timestamp;
    });

    const logsByDate: { [dateString: string]: Record<string, any>[] } = {};
    sortedLogs.forEach(log => {
      const date = new Date(Date.parse(log.timestamp));
      const year = date.getFullYear();
      const month = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);

      const dateString = `${year}/${month}/${day}`;

      logsByDate[dateString] = logsByDate[dateString] || [];
      logsByDate[dateString].push(log);
    });

    return Object.entries(logsByDate).reverse();
  },
  exerciseLogExerciseTypes(state: any) {
    if (!state.exerciseLogs) {
      return undefined;
    }

    const logs = [...state.exerciseLogs];

    const availableExerciseTypes: { [key: string]: number } = {};

    logs.forEach(log => {
      let previousCount =
        availableExerciseTypes[log.exercise.type] === undefined
          ? 0
          : availableExerciseTypes[log.exercise.type];
      previousCount += 1;
      availableExerciseTypes[log.exercise.type] = previousCount;
    });

    return availableExerciseTypes;
  },
  learningStats(state: any) {
    return state.learningStats;
  },
  recentExercises(state: any) {
    return state.recentExercises;
  },
  loading(state: any) {
    return state.loading;
  }
};

export { historyGetters };
